import { render, staticRenderFns } from "./MainBannerList.vue?vue&type=template&id=2278f6ec&scoped=true"
import script from "./MainBannerList.vue?vue&type=script&lang=js"
export * from "./MainBannerList.vue?vue&type=script&lang=js"
import style0 from "./MainBannerList.vue?vue&type=style&index=0&id=2278f6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278f6ec",
  null
  
)

export default component.exports